import axios from "axios";
import { handleAxiosErrors, getRessource } from "../utils";

const AMII = "/amii";
const GET_AMII_WTK = `${AMII}/get-AMII-zone`;

export const getAmiiVendee = abort =>
  axios
    .get(GET_AMII_WTK, {
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));
